// !function(){"use strict";customElements.get("recently-viewed")||customElements.define("recently-viewed",class extends HTMLElement{constructor(){super(),this.section=this.closest("related-products"),this.sectionId=this.section?.dataset.sectionId,this.howManyToShow=parseInt(this.dataset.limit)||3}connectedCallback(){Shopify.Products.showRecentlyViewed({howManyToShow:this.howManyToShow,wrapperId:`recently-viewed-products-${this.sectionId}`,section:this.section,onComplete:e=>{e.parentElement.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}))}})}})}();
!(function () {
    "use strict";
    customElements.get("recently-viewed") ||
        customElements.define(
            "recently-viewed",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.section = this.closest("related-products")),
                        (this.sectionId = this.section?.dataset.sectionId),
                        (this.howManyToShow =
                            parseInt(this.dataset.limit) || 3);
                }
                connectedCallback() {
                    var callbackFired = false;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: this.howManyToShow,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (e) => {
                            callbackFired = true;
                            const container = document.getElementById(`recently-viewed-products-${this.sectionId}`);
                            const n = container.querySelectorAll('.product-grid-item').length;
                            // If no products found, just dispatch the event so the tab gets hidden
                            if (n === 0) {
                                this.dispatchEvent(
                                    new CustomEvent("theme:recently-viewed:loaded", { bubbles: false })
                                );
                                return;
                            }
                            $('.recently-viewed__dots').attr('data-size', n);
                            var html = '';
                            for(var i=0; i<n; i++){
                                if(i == 0){
                                    html += '<div class="recently-viewed__dot active" data-index="'+i+'"></div>';
                                }else{
                                    html += '<div class="recently-viewed__dot" data-index="'+i+'"></div>';
                                }
                            }
                            $('.recently-viewed__dots').html(html);
                            var $rvSlider = $(`#recently-viewed-products-${this.sectionId}`);
                            $rvSlider.slick({
                                dots: false,
                                arrows: true,
                                infinite: true,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                swipe: true,
                                prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><div xmlns="" id="divScriptsUsed" style="display: none"/><script xmlns="" id="globalVarsDetection" src="chrome-extension://cmkdbmfndkfgebldhnkbfhlneefdaaip/js/wrs_env.js"/></svg></div>',
                                nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><div xmlns="" id="divScriptsUsed" style="display: none"/><script xmlns="" id="globalVarsDetection" src="chrome-extension://cmkdbmfndkfgebldhnkbfhlneefdaaip/js/wrs_env.js"/></svg></div>',
                                responsive: [
                                {
                                    breakpoint: 1440,
                                    settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 1140,
                                    settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 1000,
                                    settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                    }
                                }
                                ]
                            });

                            // Recalculate slider height after images load to prevent clipping
                            var $rvImages = $rvSlider.find('img');
                            var rvLoadedCount = 0;
                            var rvTotalImages = $rvImages.length;
                            if (rvTotalImages > 0) {
                                $rvImages.each(function() {
                                    if (this.complete) {
                                        rvLoadedCount++;
                                        if (rvLoadedCount === rvTotalImages) {
                                            $rvSlider.slick('setPosition');
                                        }
                                    } else {
                                        $(this).on('load error', function() {
                                            rvLoadedCount++;
                                            if (rvLoadedCount === rvTotalImages) {
                                                $rvSlider.slick('setPosition');
                                            }
                                        });
                                    }
                                });
                            }

                            // Hide dots and arrows when all slides fit on screen
                            function updateRecentDotsVisibility() {
                                var slickData = $rvSlider.slick('getSlick');
                                var $dots = $('.recently-viewed__dots');
                                var $arrows = $rvSlider.find('.slick-arrow');
                                if (slickData.slideCount <= slickData.options.slidesToShow) {
                                    $dots.hide();
                                    $arrows.hide();
                                } else {
                                    $dots.show();
                                    $arrows.show();
                                }
                            }
                            updateRecentDotsVisibility();
                            $(window).on('resize', function() {
                                setTimeout(updateRecentDotsVisibility, 300);
                            });

                            $('.recently-viewed__dot').css('width', 100/n+'%');
                            $rvSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                                $('.recently-viewed__dot').removeClass('active');
                                $('.recently-viewed__dot[data-index="'+nextSlide+'"]').addClass('active');
                            });
                            $('.recently-viewed__dot').click(function(){
                                var i = $(this).data('index');
                                $rvSlider.slick('slickGoTo', i);
                            });
                            
                            const items = document.querySelectorAll('.product-grid-item__title');
                            let maxHeight = 0;
                            items.forEach(item => {
                                const height = item.offsetHeight;
                                if (height > maxHeight) {
                                    maxHeight = height;
                                }
                            });
                            items.forEach(item => {
                                item.style.height = maxHeight + 'px';
                            });

                            e.parentElement.dispatchEvent(
                                new CustomEvent(
                                    "theme:recently-viewed:loaded",
                                    { bubbles: !1 }
                                )
                            );
                        },
                    });
                    // Fallback: if onComplete never fires (no recently viewed products in storage),
                    // dispatch the loaded event so the tab-hiding logic in related-products.js runs
                    setTimeout(() => {
                        if (!callbackFired) {
                            this.dispatchEvent(
                                new CustomEvent("theme:recently-viewed:loaded", { bubbles: false })
                            );
                        }
                    }, 500);
                }
            }
        );
})();